import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFilter = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M1.966.083A1.46 1.46 0 0 1 2.452 0h19.096c.166 0 .33.028.486.083a2.938 2.938 0 0 1 1.47 4.407 1.59 1.59 0 0 1-.134.17l-6.963 7.66v9.714a1.47 1.47 0 0 1-2.35 1.176L8.18 18.803a1.469 1.469 0 0 1-.588-1.175V12.32L.63 4.66a1.47 1.47 0 0 1-.133-.17A2.938 2.938 0 0 1 1.966.083Zm1.069 2.855 7.114 7.826c.246.27.382.622.382.988v5.141l2.938 2.203v-7.344c0-.366.136-.718.382-.988l7.114-7.826H3.035Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
